import { defineMessage } from 'services/localization';

export const messages = {
    addAlternativeRule: defineMessage('add_an_alternative_rule'),
    addAlternativeRuleTitle: defineMessage('add_another_rule_block__ated_as_an_or_condition'),
    removeRule: defineMessage('remove_a_rule'),
    removeRuleTitle: defineMessage('remove_this_rule_block_for_approvers'),
    copyRuleToUser: defineMessage('copy_rule_to_user'),
};
